import RestDataService from '@yakit/core/api/RestDataService'
import { problemHandler } from '@yakit/ui/svelte'

/**
 * Customer Rest Api additions
 */
 export default function(opts){

  let detApi = RestDataService({ ...opts, key: 'ipay/payTran' })

  /**
   * amount sums for payment
   * @param {Object} params
   */
  detApi.sumTotals = async (queryParams) => {
    const fields = ['amount', 'surcharge', 'applyAmount']
    const projections = {}
    fields.forEach(field => projections[field] = 'sum')
    const params = {
      projections,
      ...queryParams
    }

    let searchParams = detApi.setupQueryParams(params)
    const res = await detApi.fetch({ searchParams }).json()
    const dta = res.data[0]
    const values = {}
    fields.forEach(field => values[field] = isNaN(dta[`${field}`]) ? '' : parseFloat(dta[`${field}`]))
    
    return values
  }

  detApi.void = async (id) => { 
    let data
    let status
    try {
        const res = await detApi.fetch({ method: 'POST', path: `${id}/void` })
        status = res.status
        const data = await res.json()
        return {data, ok: okStatus(status)}
    } catch (e) {
        problemHandler.handleError(e)
    }
    return {data, ok: okStatus(status)}
  }

  detApi.refund = async (id) => { 
    let data
    let status
    try {
        const res = await detApi.fetch({ method: 'POST', path: `${id}/refund` })
        status = res.status
        const data = await res.json()
        return {data, ok: okStatus(status)}
    } catch (e) {
        problemHandler.handleError(e)
    }
    return {data, ok: okStatus(status)}
  }

  return detApi
}

const okStatus = (status) => {
  return status >= 200 && status < 300
}